import URLS from "../../../constants/urls.json";
import superagent from "superagent";
const TOKEN_AUTH_URL = URLS.TOKEN_AUTH_URL;


const hackerModeGetAuthToken = ( apikey ) => {
  return superagent.post( TOKEN_AUTH_URL ).send({ apikey: apikey })
    .catch( err => { console.log("error authenticating") })
    .then(( response ) => {
      const token = response.body.token;
      return token;
    })
}

export default hackerModeGetAuthToken;
